define('charts/layers/timefocus',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TimeFocus = void 0;
    var TimeFocus = /** @class */ (function () {
        function TimeFocus() {
        }
        TimeFocus.prototype.init = function (chart) {
            this.chart = chart;
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "focus")
                .style("display", "none");
            this.svgLine = this.svgGroup.append("line")
                .attr("class", "focus-line")
                .style("stroke-width", 1)
                .style("stroke", "#666");
        };
        TimeFocus.prototype.update = function (chart) {
            this.svgLine
                .attr("y1", chart.yAxis[0].scale.range()[0])
                .attr("y2", chart.yAxis[0].scale.range()[1]);
        };
        TimeFocus.prototype.drawFocus = function (d) {
            if (d && d.millis && this.chart) {
                var xScaled = Math.floor(this.chart.xAxis.scale(d.date)) + 0.5;
                this.svgLine
                    .attr("x1", xScaled)
                    .attr("x2", xScaled);
                this.svgGroup.style("display", null);
            }
            else {
                this.svgGroup.style("display", "none");
            }
        };
        TimeFocus.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return TimeFocus;
    }());
    exports.TimeFocus = TimeFocus;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/timefocus.js.map;
